import { Button, TextField } from '@medly-components/core';
import { Container, Content, DrawerWrapper, Header } from './Feedback.styled';
import { useState } from 'react';
import { useBoolean, useIsMobile } from 'hooks';
import { useSubmitFeedback } from 'hooks/user/useSubmitFeedback';
import { useUserContext } from 'context/UserContext';
import { useRegionContext } from 'context/RegionContext';
import { useZoneContext } from 'context/ZoneContext';
import { DialogBox } from 'components/common';
import { useAnalytics } from 'hooks/useAnalytics/useAnalytics';

type Feedback = { onClose: () => void };
export const Feedback = ({ onClose }: Feedback) => {
    const [feedback, setFeedback] = useState('');
    const isMobile = useIsMobile();
    const [open, setOpen] = useState(true);
    const { submitFeedback, isMutating } = useSubmitFeedback();
    const { user } = useUserContext();
    const { region } = useRegionContext();
    const { selectedStation, zone } = useZoneContext();
    const { value: isShowSuccessPopup, setTrue: showSuccessPopup } = useBoolean();
    const { captureMantaCareEvent } = useAnalytics();

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    const onFeedbackSuccess = () => {
        showSuccessPopup();
        captureMantaCareEvent({
            type: 'map',
            action: 'drawer_feedback',
            metadata: {
                region: { id: region.id, name: region.name },
                map: { name: region.map.name },
                zone: { name: zone.name },
                station: {
                    id: selectedStation!.id,
                    name: selectedStation!.name,
                    type: selectedStation!.type,
                    description: selectedStation!.description
                }
            }
        });
    };

    const onFeedbackSubmit = async () => {
        await submitFeedback(
            {
                userID: user!.id,
                regionID: region.id,
                stationID: selectedStation!.id,
                feedback,
                metadata: {
                    zone: zone.name,
                    regionName: region.name,
                    mapName: region.map.name,
                    stationName: selectedStation!.name,
                    stationDescription: selectedStation!.description
                }
            },
            { onSuccess: onFeedbackSuccess }
        );
    };
    const handleSuccessPopupClose = () => {
        handleClose();
    };

    if (isShowSuccessPopup) {
        return (
            <DialogBox
                open={true}
                title="Thank You!"
                content={
                    "Your suggestion has been received. We're grateful you're part of the Manta Cares community and helping us improve!"
                }
                submitButtonLabel="Return to Map"
                onClose={handleSuccessPopupClose}
                submit={handleSuccessPopupClose}
            />
        );
    }

    return (
        <Container>
            <DrawerWrapper open={open} position="right" width={isMobile ? '100%' : '54rem'} onClose={handleClose}>
                <Header>{`We're Listening!`}</Header>
                <Content>
                    <TextField
                        value={feedback}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFeedback(e.target.value)}
                        placeholder="We're always looking to improve. Share your suggestions on how this drawer can be improved!"
                        multiline={true}
                        variant="outlined"
                        minRows={3}
                    />
                    <Button
                        edges="square"
                        fullWidth
                        size="M"
                        type="button"
                        onClick={onFeedbackSubmit}
                        disabled={!feedback}
                        isLoading={isMutating}
                    >
                        Send Suggestion
                    </Button>
                </Content>
            </DrawerWrapper>
        </Container>
    );
};
